/* eslint-disable object-curly-spacing */ 
/* eslint-disable no-undef */ 
/* eslint-disable own-handles */ 
/* eslint-disable no-innerhtml-assign */ 
/* eslint-disable consistent-method-names */ 
/* eslint-disable no-jsdoc */ 
define([], function() {
    'use strict';

    /**
     * @ignore
     * This map contains:
     * * Identifier: 'pl-PL' - by this identifier we search in the map for locale
     * * Label: 'Polish' - label, which will be returned by getLabel function in Locale prototype
     * * Service specific options (routing, search, traffic):
     * * - fallback - identifies to which language code should be used, because for different services
     * *              different language codes are used. For example pl-PL is correct one for search, but pl is used by
     * *              routing. This field is also used by the method getLocaleFor in locale prototype
     * * - isNative - describes if this language is supported by service. For example 'en-AU' is supported by search
     * *            but it is not supported by routing, so it will be defaulted to 'en-GB' for it. Also language list
     *              for service is determined by this field. If you call localeService.getLocalesFor('routing')
     *              only languages with routing.isNative === true will be returned.
     */
    var map = {
        'af-ZA': {
            label: 'Afrikaans',
            routing: {
                fallback: 'af-ZA',
                isNative: true
            },
            search: {
                fallback: 'af-ZA',
                isNative: true
            },
            traffic: {
                fallback: 'en', //fallback to en
                isNative: false
            },
            maps: {
                fallback: 'en-GB', //fallback
                isNative: false
            }
        },
        'ar': {
            label: 'Arabic',
            routing: {
                fallback: 'ar',
                isNative: true
            },
            search: {
                fallback: 'ar',
                isNative: true
            },
            traffic: {
                fallback: 'en', //fallback to en
                isNative: false
            },
            maps: {
                fallback: 'ar',
                isNative: true
            }
        },
        'bg-BG': {
            label: 'Bulgarian',
            routing: {
                fallback: 'bg-BG',
                isNative: true
            },
            search: {
                fallback: 'bg-BG',
                isNative: true
            },
            traffic: {
                fallback: 'en', //fallback to en
                isNative: false
            },
            maps: {
                fallback: 'bg-BG',
                isNative: true
            }
        },
        'ca-ES': {
            label: 'Spanish (Catalan)',
            routing: {
                fallback: 'es-ES', //fallback to spanish
                isNative: false
            },
            search: {
                fallback: 'ca-ES',
                isNative: true
            },
            traffic: {
                fallback: 'ca',
                isNative: true
            },
            maps: {
                fallback: 'es-ES', //fallback
                isNative: false
            }
        },
        'cs-CZ': {
            label: 'Czech',
            routing: {
                fallback: 'cs-CZ',
                isNative: true
            },
            search: {
                fallback: 'cs-CZ',
                isNative: true
            },
            traffic: {
                fallback: 'cs',
                isNative: true
            },
            maps: {
                fallback: 'cs-CZ',
                isNative: true
            }
        },
        'da-DK': {
            label: 'Danish',
            routing: {
                fallback: 'da-DK',
                isNative: true
            },
            search: {
                fallback: 'da-DK',
                isNative: true
            },
            traffic: {
                fallback: 'da',
                isNative: true
            },
            maps: {
                fallback: 'da-DK',
                isNative: true
            }
        },
        'nl-BE': {
            label: 'Dutch (Belgium)',
            routing: {
                fallback: 'nl-NL', //fallback to nl-NL
                isNative: false
            },
            search: {
                fallback: 'nl-BE',
                isNative: true
            },
            traffic: {
                fallback: 'nl',
                isNative: false
            },
            maps: {
                fallback: 'nl-NL', //fallback
                isNative: false
            }
        },
        'nl-NL': {
            label: 'Dutch',
            routing: {
                fallback: 'nl-NL',
                isNative: true
            },
            search: {
                fallback: 'nl-NL',
                isNative: true
            },
            traffic: {
                fallback: 'nl',
                isNative: true
            },
            maps: {
                fallback: 'nl-NL',
                isNative: true
            }
        },
        'en-AU': {
            label: 'English (Australia)',
            routing: {
                fallback: 'en-GB', //falback to en-gb
                isNative: false
            },
            search: {
                fallback: 'en-AU',
                isNative: true
            },
            traffic: {
                fallback: 'en', //fallback to en
                isNative: false
            },
            maps: {
                fallback: 'en-AU',
                isNative: true
            }
        },
        'en-NZ': {
            label: 'English (New Zealand)',
            routing: {
                fallback: 'en-GB', //falback to en-gb
                isNative: false
            },
            search: {
                fallback: 'en-NZ',
                isNative: true
            },
            traffic: {
                fallback: 'en', //fallback to en
                isNative: false
            },
            maps: {
                fallback: 'en-NZ',
                isNative: true
            }
        },
        'en-GB': {
            label: 'English (Great Britain)',
            routing: {
                fallback: 'en-GB',
                isNative: true
            },
            search: {
                fallback: 'en-GB',
                isNative: true
            },
            traffic: {
                fallback: 'en',
                isNative: true
            },
            maps: {
                fallback: 'en-GB',
                isNative: true
            }
        },
        'en-US': {
            label: 'English (USA)',
            routing: {
                fallback: 'en-US',
                isNative: true
            },
            search: {
                fallback: 'en-US',
                isNative: true
            },
            traffic: {
                fallback: 'en',
                isNative: false //fallback to en
            },
            maps: {
                fallback: 'en-US',
                isNative: true
            }
        },
        'en-CA': {
            label: 'English (Canada)',
            routing: {
                fallback: 'en-US', //fallback
                isNative: false
            },
            search: {
                fallback: 'en-US', //fallback
                isNative: false
            },
            traffic: {
                fallback: 'en',
                isNative: false //fallback to en
            },
            maps: {
                fallback: 'en-CA',
                isNative: true
            }
        },
        'et-EE': {
            label: 'Estonian',
            routing: {
                fallback: 'en-GB', //falback to en-gb
                isNative: false
            },
            search: {
                fallback: 'et-EE',
                isNative: true
            },
            traffic: {
                fallback: 'en',
                isNative: false //fallback to en
            },
            maps: {
                fallback: 'en-GB', //fallback
                isNative: false
            }
        },
        'fi-FI': {
            label: 'Finnish',
            routing: {
                fallback: 'fi-FI',
                isNative: true
            },
            search: {
                fallback: 'fi-FI',
                isNative: true
            },
            traffic: {
                fallback: 'fi',
                isNative: true
            },
            maps: {
                fallback: 'fi-FI',
                isNative: true
            }
        },
        'fr-CA': {
            label: 'French (Canada)',
            routing: {
                fallback: 'fr-FR',
                isNative: false //fallback to fr-FR
            },
            search: {
                fallback: 'fr-CA',
                isNative: true
            },
            traffic: {
                fallback: 'fr',
                isNative: false //fallback to fr
            },
            maps: {
                fallback: 'fr-FR', //fallback
                isNative: false
            }
        },
        'fr-FR': {
            label: 'French',
            routing: {
                fallback: 'fr-FR',
                isNative: true
            },
            search: {
                fallback: 'fr-FR',
                isNative: true
            },
            traffic: {
                fallback: 'fr',
                isNative: true
            },
            maps: {
                fallback: 'fr-FR',
                isNative: true
            }
        },
        'de-DE': {
            label: 'German',
            routing: {
                fallback: 'de-DE',
                isNative: true
            },
            search: {
                fallback: 'de-DE',
                isNative: true
            },
            traffic: {
                fallback: 'de',
                isNative: true
            },
            maps: {
                fallback: 'de-DE',
                isNative: true
            }
        },
        'el-GR': {
            label: 'Greek',
            routing: {
                fallback: 'el-GR',
                isNative: true
            },
            search: {
                fallback: 'el-GR',
                isNative: true
            },
            traffic: {
                fallback: 'en',
                isNative: false //fallback to en
            },
            maps: {
                fallback: 'el-GR',
                isNative: true
            }
        },
        'hr-HR': {
            label: 'Croatian',
            routing: {
                fallback: 'en-GB',
                isNative: false //fallback to en-GB
            },
            search: {
                fallback: 'hr-HR',
                isNative: true
            },
            traffic: {
                fallback: 'en',
                isNative: false //fallback to en
            },
            maps: {
                fallback: 'en-GB', //fallback
                isNative: false
            }
        },
        'hu-HU': {
            label: 'Hungarian',
            routing: {
                fallback: 'hu-HU',
                isNative: true
            },
            search: {
                fallback: 'hu-HU',
                isNative: true
            },
            traffic: {
                fallback: 'hu',
                isNative: true
            },
            maps: {
                fallback: 'hu-HU',
                isNative: true
            }
        },
        'id-ID': {
            label: 'Indonesian',
            routing: {
                fallback: 'id-ID',
                isNative: true
            },
            search: {
                fallback: 'en-GB',
                isNative: false //fallback to en-GB
            },
            traffic: {
                fallback: 'en',
                isNative: false //fallback to en
            },
            maps: {
                fallback: 'id-ID',
                isNative: true
            }
        },
        'it-IT': {
            label: 'Italian',
            routing: {
                fallback: 'it-IT',
                isNative: true
            },
            search: {
                fallback: 'it-IT',
                isNative: true
            },
            traffic: {
                fallback: 'it',
                isNative: true
            },
            maps: {
                fallback: 'it-IT',
                isNative: true
            }
        },
        'ko-KR': {
            label: 'Korean',
            routing: {
                fallback: 'ko-KR',
                isNative: true
            },
            search: {
                fallback: 'en-GB',
                isNative: false //fallback to en-GB
            },
            traffic: {
                fallback: 'en',
                isNative: false //fallback to en
            },
            maps: {
                fallback: 'ko-KR',
                isNative: true
            }
        },
        'lv-LV': {
            label: 'Latvian',
            routing: {
                fallback: 'en-GB', //fallback to en-GB
                isNative: false
            },
            search: {
                fallback: 'lv-LV',
                isNative: true
            },
            traffic: {
                fallback: 'en',
                isNative: false //fallback to en
            },
            maps: {
                fallback: 'en-GB', //fallback
                isNative: false
            }
        },
        'lt-LT': {
            label: 'Lithuanian',
            routing: {
                fallback: 'lt-LT',
                isNative: true
            },
            search: {
                fallback: 'lt-LT',
                isNative: true
            },
            traffic: {
                fallback: 'en',
                isNative: false //fallback to en
            },
            maps: {
                fallback: 'lt-LT',
                isNative: true
            }
        },
        'ms-MY': {
            label: 'Malay',
            routing: {
                fallback: 'ms-MY',
                isNative: true
            },
            search: {
                fallback: 'ms-MY',
                isNative: true
            },
            traffic: {
                fallback: 'en',
                isNative: false //fallback to en
            },
            maps: {
                fallback: 'ms-MY',
                isNative: true
            }
        },
        'NGT': {
            label: 'Neutral Ground Truth',
            routing: {
                fallback: 'en-GB', //fallback to en-gb
                isNative: false
            },
            search: {
                fallback: 'en-GB', //fallback to en-gb
                isNative: false
            },
            traffic: {
                fallback: 'en', //fallback to en
                isNative: false
            },
            maps: {
                fallback: 'NGT',
                isNative: true
            }
        },
        'NGT-Latn': {
            label: 'Neutral Ground Truth (Latin)',
            routing: {
                fallback: 'en-GB', //fallback to en-gb
                isNative: false
            },
            search: {
                fallback: 'en-GB', //fallback to en-gb
                isNative: false
            },
            traffic: {
                fallback: 'en', //fallback to en
                isNative: false
            },
            maps: {
                fallback: 'NGT-Latn',
                isNative: true
            }
        },
        'no-NO': {
            label: 'Norwegian',
            routing: {
                fallback: 'nb-NO',
                isNative: false
            },
            search: {
                fallback: 'no-NO',
                isNative: true
            },
            traffic: {
                fallback: 'no',
                isNative: true
            },
            maps: {
                fallback: 'nb-NO',
                isNative: false
            }
        },
        'nb-NO': {
            label: 'Norwegian',
            routing: {
                fallback: 'nb-NO',
                isNative: true
            },
            search: {
                fallback: 'no-NO',
                isNative: false
            },
            traffic: {
                fallback: 'no',
                isNative: false
            },
            maps: {
                fallback: 'nb-NO',
                isNative: true
            }
        },
        'pl-PL': {
            label: 'Polish',
            routing: {
                fallback: 'pl-PL',
                isNative: true
            },
            search: {
                fallback: 'pl-PL',
                isNative: true
            },
            traffic: {
                fallback: 'pl',
                isNative: true
            },
            maps: {
                fallback: 'pl-PL',
                isNative: true
            }
        },
        'pt-BR': {
            label: 'Portuguese (Brazil)',
            routing: {
                fallback: 'pt-BR',
                isNative: true
            },
            search: {
                fallback: 'pt-BR',
                isNative: true
            },
            traffic: {
                fallback: 'pt',
                isNative: false //fallback to pt
            },
            maps: {
                fallback: 'pt-BR',
                isNative: true
            }
        },
        'pt-PT': {
            label: 'Portuguese (Portugal)',
            routing: {
                fallback: 'pt-PT',
                isNative: true
            },
            search: {
                fallback: 'pt-PT',
                isNative: true
            },
            traffic: {
                fallback: 'pt',
                isNative: true
            },
            maps: {
                fallback: 'pt-PT',
                isNative: true
            }
        },
        'ru-Cyrl-RU': {
            label: 'Russian (Cyrillic)',
            routing: {
                fallback: 'ru-RU',
                isNative: false
            },
            search: {
                fallback: 'ru-RU',
                isNative: false
            },
            traffic: {
                fallback: 'en',
                isNative: false //fallback to en
            },
            maps: {
                fallback: 'ru-Cyrl-RU',
                isNative: true
            }
        },
        'ru-Latn-RU': {
            label: 'Russian (Latin)',
            routing: {
                fallback: 'ru-RU',
                isNative: false
            },
            search: {
                fallback: 'ru-RU',
                isNative: false
            },
            traffic: {
                fallback: 'en',
                isNative: false //fallback to en
            },
            maps: {
                fallback: 'ru-Latn-RU',
                isNative: true
            }
        },
        'ru-RU': {
            label: 'Russian',
            routing: {
                fallback: 'ru-RU',
                isNative: true
            },
            search: {
                fallback: 'ru-RU',
                isNative: true
            },
            traffic: {
                fallback: 'en',
                isNative: false //fallback to en
            },
            maps: {
                fallback: 'ru-RU',
                isNative: true
            }
        },
        'sk-SK': {
            label: 'Slovak',
            routing: {
                fallback: 'sk-SK',
                isNative: true
            },
            search: {
                fallback: 'sk-SK',
                isNative: true
            },
            traffic: {
                fallback: 'sk',
                isNative: true
            },
            maps: {
                fallback: 'sk-SK',
                isNative: true
            }
        },
        'sl-SI': {
            label: 'Slovenian',
            routing: {
                fallback: 'sl-SI',
                isNative: true
            },
            search: {
                fallback: 'sl-SI',
                isNative: true
            },
            traffic: {
                fallback: 'en',
                isNative: false //fallback to en
            },
            maps: {
                fallback: 'sl-SI',
                isNative: true
            }
        },
        'es-ES': {
            label: 'Spanish (Castilian)',
            routing: {
                fallback: 'es-ES',
                isNative: true
            },
            search: {
                fallback: 'es-ES',
                isNative: true
            },
            traffic: {
                fallback: 'es',
                isNative: true
            },
            maps: {
                fallback: 'es-ES',
                isNative: true
            }
        },
        'es-419': {
            label: 'Spanish (Latin American)',
            routing: {
                fallback: 'es-ES',
                isNative: false //fallback to es-ES
            },
            search: {
                fallback: 'es-419',
                isNative: true
            },
            traffic: {
                fallback: 'es',
                isNative: false //fallback to es
            },
            maps: {
                fallback: 'es-ES', //fallback
                isNative: false
            }
        },
        'es-MX': {
            label: 'Spanish (Mexico)',
            routing: {
                fallback: 'es-MX',
                isNative: true
            },
            search: {
                fallback: 'es-ES', //fallback to es-ES
                isNative: false
            },
            traffic: {
                fallback: 'es',
                isNative: false //falback to es
            },
            maps: {
                fallback: 'es-MX',
                isNative: true
            }
        },
        'sv-SE': {
            label: 'Swedish',
            routing: {
                fallback: 'sv-SE',
                isNative: true
            },
            search: {
                fallback: 'sv-SE',
                isNative: true
            },
            traffic: {
                fallback: 'sv',
                isNative: true
            },
            maps: {
                fallback: 'sv-SE',
                isNative: true
            }
        },
        'th-TH': {
            label: 'Thai',
            routing: {
                fallback: 'th-TH',
                isNative: true
            },
            search: {
                fallback: 'en-GB',
                isNative: false //fallback to en-GB
            },
            traffic: {
                fallback: 'en',
                isNative: false //fallback to en
            },
            maps: {
                fallback: 'th-TH',
                isNative: true
            }
        },
        'tr-TR': {
            label: 'Turkish',
            routing: {
                fallback: 'tr-TR',
                isNative: true
            },
            search: {
                fallback: 'tr-TR',
                isNative: true
            },
            traffic: {
                fallback: 'tr',
                isNative: true
            },
            maps: {
                fallback: 'tr-TR',
                isNative: true
            }
        },
        'zh-CN': {
            label: 'Chinese (PRC)',
            routing: {
                fallback: 'zh-TW', //fallback to taiwan
                isNative: false
            },
            search: {
                fallback: 'zh-CN',
                isNative: true
            },
            traffic: {
                fallback: 'en', //falback to english
                isNative: false
            },
            maps: {
                fallback: 'zh-TW', //fallback
                isNative: false
            }
        },
        'zh-TW': {
            label: 'Chinese (Taiwan)',
            routing: {
                fallback: 'zh-TW',
                isNative: true
            },
            search: {
                fallback: 'zh-TW',
                isNative: true
            },
            traffic: {
                fallback: 'en', //falback to english
                isNative: false
            },
            maps: {
                fallback: 'zh-TW',
                isNative: true
            }
        }
    };

    return map;
});



// WEBPACK FOOTER //
// ./config/language/languageTypesMapping.js